import React from 'react';

export const DealMade = () => (
  <>
    <defs>
      <mask id="n5rnb" width="2" height="2" x="-1" y="-1">
        <path fill="#fff" d="M72 31h69v86H72z" />
        <path d="M119.463 31.442h-46.21a.309.309 0 0 0-.307.31v84.106c0 .171.138.31.307.31h66.523c.17 0 .308-.139.308-.31V52.065z" />
      </mask>
      <filter
        id="n5rna"
        width="119"
        height="139"
        x="47"
        y="6"
        filterUnits="userSpaceOnUse"
      >
        <feOffset dy="3" in="SourceGraphic" result="FeOffset2200Out" />
        <feGaussianBlur
          in="FeOffset2200Out"
          result="FeGaussianBlur2201Out"
          stdDeviation="6 6"
        />
      </filter>
    </defs>
    <g transform="matrix(6.4348147,0,0,6.4348147,-4.6201944,73.710805)">
      <path
        fill="none"
        stroke="#c2ccd8"
        strokeWidth="4"
        strokeMiterlimit="50"
        d="m 118.23,28.878 v 0 -9.548 a 0.303,0.303 0 0 0 -0.303,-0.303 H 3.022 A 0.304,0.304 0 0 0 2.718,19.33 v 84.357 c 0,0.166 0.136,0.3 0.304,0.3 h 114.965 a 0.24,0.24 0 0 0 0.242,-0.24 z"
      />
      <g opacity="0.3">
        <g opacity="0.3">
          <path
            d="M 113.897,31.442 H 67.689 a 0.309,0.309 0 0 0 -0.31,0.31 v 84.106 c 0,0.171 0.139,0.31 0.31,0.31 h 66.521 c 0.172,0 0.31,-0.139 0.31,-0.31 V 52.065 Z"
            fill="#c2ccd8"
          />
        </g>
      </g>
      <g filter="url(#n5rna)">
        <path
          d="m 119.463,31.442 h -46.21 a 0.309,0.309 0 0 0 -0.307,0.31 v 84.106 c 0,0.171 0.138,0.31 0.307,0.31 h 66.523 c 0.17,0 0.308,-0.139 0.308,-0.31 V 52.065 Z"
          mask="url(#n5rnb)"
          fill="none"
        />
        <path
          d="m 119.463,31.442 h -46.21 a 0.309,0.309 0 0 0 -0.307,0.31 v 84.106 c 0,0.171 0.138,0.31 0.307,0.31 h 66.523 c 0.17,0 0.308,-0.139 0.308,-0.31 V 52.065 Z"
          fillOpacity="0.16000001"
        />
      </g>
      <path
        d="m 119.463,31.442 h -46.21 a 0.309,0.309 0 0 0 -0.307,0.31 v 84.106 c 0,0.171 0.138,0.31 0.307,0.31 h 66.523 c 0.17,0 0.308,-0.139 0.308,-0.31 V 52.065 Z"
        fill="#ffffff"
      />
      <path
        d="m 82.997,62.743 v -4.185 h 47.037 v 4.185 z"
        fill="#0686d8"
        fillOpacity="1"
      />
      <path
        d="M 82.997,76.346 V 72.16 h 47.037 v 4.185 z"
        fill="#0686d8"
        fillOpacity="1"
      />
      <path
        d="m 82.997,89.95 v -4.184 h 47.037 v 4.185 z"
        fill="#0686d8"
        fillOpacity="1"
      />
      <path
        d="m 82.997,103.554 v -4.185 h 25.928 v 4.185 z"
        fill="#0686d8"
        fillOpacity="1"
      />
      <path
        fill="#0686d8"
        fillOpacity="1"
        d="m 119.463,31.442 v 20.35 c 0,0.15 0.121,0.273 0.274,0.273 h 20.347 z"
      />
      <path
        d="M 23.022,61.708 V 51.69 h 9.75 v 10.018 z"
        fill="#0686d8"
        fillOpacity="1"
      />
      <path
        transform="scale(10.8)"
        fill="#c2ccd8"
        strokeWidth="0.09259259"
        d="M 0.25195312,4.7207031 V 5.046875 H 1.96875 V 5.8769531 H 3.1972656 V 5.046875 H 6.2382812 V 4.7207031 Z M 2.2949219,5.046875 H 2.8710938 V 5.5507812 H 2.2949219 Z M 8.0449074,1.8351852 H 7.7176852 V 0.43962963 c 0,-0.0573148 -0.046481,-0.10388889 -0.1037037,-0.10388889 H 3.4346296 c -0.057222,0 -0.1038889,0.0465741 -0.1038889,0.10388889 V 1.8351852 H 3.0035185 V 0.43953704 A 0.43157407,0.43157407 0 0 1 3.4346296,0.00833333 h 4.1793519 a 0.43148148,0.43148148 0 0 1 0.4309259,0.43111111 z"
      />
      <path
        fill="#0686d8"
        fillOpacity="1"
        d="m 137.576,13.583 3.308,-6.759 6.244,4.2 21.427,79.968 -9.552,2.56 z"
      />
      <g opacity="0.3">
        <g opacity="0.3">
          <path
            fill="#414042"
            d="m 143.949,9.01 22.143,82.642 2.463,-0.66 -21.427,-79.969 -6.244,-4.199 -0.019,0.038 z"
          />
        </g>
      </g>
      <path
        fill="#c2ccd8"
        d="m 139.962,22.488 -0.915,-3.413 9.552,-2.56 0.915,3.414 z m 7.106,26.519 -0.914,-3.413 9.55,-2.56 0.915,3.414 z m -7.47,-40.152 -2.147,-8.013 3.414,-0.915 2.147,8.014 z m 24.629,91.915 -2.148,-8.016 3.414,-0.915 2.148,8.016 z"
      />
    </g>
  </>
);
